module.exports = __webpack_public_path__ + "3e6c138325b338221a43e327a5e56ad3.MP3";